import React, { Component } from "react";
import ProductsImage from "../../images/home-four-3-1011x800.jpg"

class ProductsSectionComponent extends Component {
    render() { 
        return (<section className="bg-white" id="proizvodi">
        <div className="shell-fluid shell-condensed">
          <div className="range range-condensed">
            <div className="cell-md-6 cell-md-6-mod-2 image-wrap-left-nt bg-gray-dark bg-image"
              style={{backgroundImage: 'url('+ProductsImage+')'}}>
              <div className="image-wrap-inner">
                <div className="range range-condensed range-inner-bordered" style={{minHeight:500}}>
                </div>
              </div>
            </div>
            <div className="cell-md-6 cell-md-6-mod-1 image-wrap-right bg-white bg-image" >
              <div className="image-wrap-inner" >
                <h2>Proizvodi za negu kose i brade</h2>
                <p className="big">
               Za vas biramo proizvode visokog kvaliteta.
    
              </p><a className="btn btn-sm btn-circle btn-white-pickled-bluewood btn-shadow" href="/zakazivanje">Zakažite svoj termin
                sada</a>
              </div>
            </div>
            
          </div>
        </div>
      </section>);
    }
}
 
export default ProductsSectionComponent;